<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div class="grid sm:flex items-center gap-2">
        <div class="flex">
          <vs-select class="w-full xl:w-32" autocomplete v-model="head" @change="onChangeData" :disabled="readonly">
            <vs-select-item v-for="(item, index) in list" :key="index" :text="item" :value="item" />
          </vs-select>
        </div>
        <div class="flex-1">
          <ml-input class="w-full" icon-pack="feather" icon="icon-search" placeholder="검색어를 입력하세요." v-model="keyword" @change="onChangeData" @keyup.enter="onKeyup" />
        </div>
      </div>
    </search-filter-item>
    <template v-else>
      <search-label-body :label="label" :label-hidden="!label" :columns="options['gridTemplateColumns']">
        <div>
          <vs-select class="w-full xl:w-32" autocomplete v-model="head" @change="onChangeData" :disabled="readonly">
            <vs-select-item v-for="(item, index) in list" :key="index" :text="item" :value="item" />
          </vs-select>
        </div>
      </search-label-body>
      <search-label-body label="검색어" :label-hidden="keywordLabelHidden" :columns="options['gridTemplateColumns']">
        <div>
          <ml-input class="w-full" :class="options.keywordInputLong ? `xl:w-500px` : 'xl:w-48'" icon-pack="feather" icon="icon-search" placeholder="검색어를 입력하세요." v-model="keyword" @change="onChangeData" @keyup.enter="onKeyup" />
        </div>
      </search-label-body>
    </template>
  </div>
</template>

<script>
import singlePageList from "@/views/boards/single-page/listIndex";
import "./scss/base.scss";
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchColumnKeyword",
  components: {
    SearchFilterItem,
    SearchLabelBody,
  },
  props: {
    label: {
      default: "검색조건",
      type: String,
    },
    value: Object | String,
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          _ck_type: "",
          _ck_keyword: "",
        };
      },
    },
    options: Object,
    onClickSearch: Function,
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile() {
      return !(this.$store.state.verticalNavMenuWidth === "default");
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.options && this.options.boardId ? this.options.boardId : this.$route.params.boardId;
    },
    list() {
      let listKey = this.options && this.options.listKey ? this.options.listKey : `${this.boardId}_list`;
      const hiddenList = this.options ? this.options.hiddenList || [] : [];
      const list = singlePageList[listKey].getHead(this.projectId);
      if (list && list.length > 0) {
        let _list = [];
        for (const item of list) {
          if (hiddenList.indexOf(item.name) === -1) {
            _list.push(item.name);
          }
        }
        // OPTION ADDLIST : 커스텀으로 추가
        if (this.options.addList) _list = [..._list, ...this.options.addList];
        return _list;
      }
      return [];
    },
    initData() {
      const _query_keys = Object.keys(this.query);
      const query = this.$route.query;
      const query_head = query[_query_keys[0]];
      const query_keyword = query[_query_keys[1]];
      const data = {
        head: query_head || "",
        keyword: query_keyword || "",
      };
      if (!data.head && this.list && this.list.length > 0) {
        data.head = this.list[0];
      }
      return data;
    },

    keywordLabelHidden() {
      return !this.isMobile;
    },
  },
  watch: {
    value(value) {
      const { head, keyword } = value;
      this.head = head;
      this.keyword = keyword;
    },
  },
  data() {
    return {
      head: "",
      keyword: "",
    };
  },
  created() {
    this.head = this.initData.head;
    this.keyword = this.initData.keyword;
    this.$emit("input", { head: this.head, keyword: this.keyword });
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    onChangeData() {
      this.$emit("input", { head: this.head, keyword: this.keyword });
      this.$emit("change", { head: this.head, keyword: this.keyword });
    },
    onKeyup() {
      this.onChangeData();
      if (this.onClickSearch) {
        this.onClickSearch();
      }
      this.$emit("handleClickSearch");
    },
    getConditions(nav, valueKey, heads) {
      const search = nav.value;
      const conditions = [];
      // 배열의 객체들을 하나의 객체로 합치기
      const types = Object.assign({}, ...heads);
      if (search[valueKey] && search[valueKey].keyword) {
        if (typeof types[search[valueKey].head] === "string") {
          conditions.push({ key: types[search[valueKey].head], operator: "LIKE", value: `%${search[valueKey].keyword}%` });
        } else if (Array.isArray(types[search[valueKey].head])) {
          const subConditions = [];
          for (const key of types[search[valueKey].head]) {
            if (subConditions.length === 0) {
              subConditions.push({ key: key, operator: "LIKE", value: `%${search[valueKey].keyword}%` });
            } else {
              subConditions.push({
                boolean: "OR",
                conditions: [{ key: key, operator: "LIKE", value: `%${search[valueKey].keyword}%` }],
              });
            }
          }
          conditions.push({ boolean: "AND", conditions: subConditions });
        }
      }
      return conditions;
    },
    onClickFilterRemove () {
      this.head = this.list && this.list[0] || "";
      this.keyword = "";
      this.onChangeData();
    }
  },
};
</script>
